// The colour-psychology trait vocabulary the classifier actually emits.
//
// Source of truth: TRAIT_DEFINITIONS in create-prints-node
// (cloudflare-generation/src/colorAffect.js), served as
// GET https://api.createprints.ai/api/collection-traits.
//
// `collection_metadata` still holds rows for the values the old classifier
// used, so anything that builds links from that table has to filter them out —
// otherwise the homepage and footer advertise collections that no print can
// belong to, which is how the Mood strip ended up half empty.
export const PRIMARY_TRAITS = [
  "Serene",
  "Quiet",
  "Grounded",
  "Intricate",
  "Balanced",
  "Uplifting",
  "Bold",
  "Energetic",
];

// Retired values, kept here so we can recognise and hide them. Old URLs are
// 301'd to their replacement in vercel.json; these never get linked afresh.
export const RETIRED_PRIMARY_TRAITS = [
  "Intense",
  "Regal",
  "Cheerful",
  "Joyful",
  "Neutral",
  "Joy",
  "Optimism",
  "Creativity",
  "Passion",
  "Enthusiasm",
  "Adventure",
  "Intellect",
  "Precision",
];

export const PRIMARY_TRAIT_COLLECTION_TYPE = "color_psychology_primary_trait";

const CURRENT_LOOKUP = new Set(
  PRIMARY_TRAITS.map((trait) => trait.toLowerCase())
);

// Anything the classifier does not emit is treated as retired, not just the
// names we happen to have listed above — a stray value left in the table by an
// older import should be hidden too.
export const isCurrentPrimaryTrait = (value) =>
  CURRENT_LOOKUP.has(String(value ?? "").toLowerCase());

// Drops rows for trait values no print can carry any more. Rows of any other
// collection type pass through untouched.
export const withoutRetiredTraits = (rows) =>
  (rows || []).filter(
    (row) =>
      row?.collection_type !== PRIMARY_TRAIT_COLLECTION_TYPE ||
      isCurrentPrimaryTrait(row?.value)
  );
